import { call, select } from 'redux-saga/effects';
import { deleteProjectThumbnail } from './deleteProjectThumbnail';
import * as selectors from '../../../../selectors';

export function* deleteCurrentProjectThumbnail(data) {
  const { projectId } = yield select(selectors.selectPath);
  yield call(deleteProjectThumbnail, projectId, data);
}
